<template><!--平台规则-->
  <div style="padding: 10px">
    <div>平台规则</div>
    <hr>
    <!--男-->
    <el-collapse v-model="activeName" accordion v-if="sex === '1'">
      <el-collapse-item title="禁止第三平台" name="1">
        <div class="collapse-item-div">● 询问个人信息添加微信qq或其他第三方平台的行为多为诈骗行为，平台禁止发送或诱导其他用户发送第三方联系方式。</div>
      </el-collapse-item>
      <el-collapse-item title="哪些情况会被封禁" name="2">
        <div class="collapse-item-div">● 发送或诱导其他用户发送第三方平台账号。</div>
        <div class="collapse-item-div">● 发送广告、色情暴力、政治敏感、诈骗相关内容。</div>
        <div class="collapse-item-div">● 使用脚本、批量复制粘贴、随机文字聊天等非正常聊天行为。</div>
        <div class="collapse-item-div">● 以辱骂、低俗等为由被举报多次并被核实的用户。</div>
        <div class="collapse-item-div">● 其他破坏平台环境的行为。</div>
      </el-collapse-item>
      <el-collapse-item title="被封禁的账号会怎么样" name="3">
        <div class="collapse-item-div">● 账号封禁期间禁止使用聊天、漂流瓶、瞬间、匹配等功能。</div>
      </el-collapse-item>
      <el-collapse-item title="封禁时间" name="4">
        <div class="collapse-item-div">● 对于违规发送（或诱导发送）第三方平台、复制粘贴、随机回复的用户首次将封禁一个月。</div>
        <div class="collapse-item-div">● 非初次违规的用户封禁时间将会增加。</div>
        <div class="collapse-item-div">● 导流/脚本/政治敏感/诈骗或其他违法行为将被永久封禁。</div>
      </el-collapse-item>
    </el-collapse>

    <!--女-->
    <el-collapse v-model="activeName" accordion v-if="sex === '2'">
      <el-collapse-item title="禁止第三平台" name="1">
        <div class="collapse-item-div">● 询问个人信息添加微信qq或其他第三方平台的行为多为诈骗行为，平台禁止发送或诱导其他用户发送第三方联系方式。</div>
      </el-collapse-item>
      <el-collapse-item title="哪些情况会被封禁" name="2">
        <div class="collapse-item-div">● 发送或诱导其他用户发送第三方平台账号。</div>
        <div class="collapse-item-div">● 发送广告、色情暴力、政治敏感、诈骗相关内容。</div>
        <div class="collapse-item-div">● 使用脚本、批量复制粘贴、随机文字聊天等非正常聊天行为。</div>
        <div class="collapse-item-div">● 以辱骂、低俗等为由被举报多次并被核实的用户。</div>
        <div class="collapse-item-div">● 其他破坏平台环境的行为。</div>
      </el-collapse-item>
      <el-collapse-item title="被封禁的账号会怎么样" name="3">
        <div class="collapse-item-div">● 账号封禁期间禁止使用聊天、漂流瓶、瞬间、匹配等功能。</div>
        <div class="collapse-item-div">● 账号封禁期间无法进行余额提取，待封禁期结束后重新提交。</div>
      </el-collapse-item>
      <el-collapse-item title="封禁时间" name="4">
        <div class="collapse-item-div">● 对于违规发送（或诱导发送）第三方平台、复制粘贴、随机回复的用户首次将封禁一个月。</div>
        <div class="collapse-item-div">● 非初次违规的用户封禁时间将会增加。</div>
        <div class="collapse-item-div">● 导流/脚本/政治敏感/诈骗或其他违法行为将被永久封禁。</div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeName: '1',
      oldActiveNames: undefined,
      sex: this.$route.query.sex
    }
  },
  methods: {},
  created() {

  }
}
</script>

<style>

</style>
